package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccessTime
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import tta.destinigo.talktoastro.shared.theme.Scale
import tta.destinigo.talktoastro.shared.theme.primaryColor

@Composable
fun QueueUserItem(
    user: QueueUser,
    modifier: Modifier = Modifier
) {
    // If the user is "You," highlight with a different color or icon
    val backgroundColor = if (user.isYou) {
        MaterialTheme.colorScheme.primary.copy(alpha = 0.1f)
    } else {
        Color.Gray.copy(alpha = 0.1f)
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
            .fillMaxWidth()
            .background(backgroundColor, shape = RoundedCornerShape(Scale.CORNER_EXTRA_SMALL))
            .padding(vertical = 8.dp, horizontal = 12.dp)
    ) {
        // Initial or avatar
        Box(
            modifier = Modifier
                .size(35.dp)
                .clip(CircleShape)
                .background(
                    if (user.isYou) primaryColor
                    else Color.Gray.copy(alpha = 0.2f)
                )
        ) {
            Text(
                text = user.name.firstOrNull()?.toString() ?: "",
                style = MaterialTheme.typography.bodyMedium,
                color = if (user.isYou) Color.White else Color.Black,
                modifier = Modifier.align(Alignment.Center)
            )
        }

        Spacer(modifier = Modifier.width(12.dp))

        // Name
        Text(
            text = if (user.isYou) "${user.name} (You)" else user.name,
            style = MaterialTheme.typography.titleSmall
        )

        Spacer(modifier = Modifier.weight(1f))

        // Wait time range if available
        if (!user.waitRange.isNullOrEmpty()) {
            // Timer icon + text
            Icon(
                imageVector = Icons.Default.AccessTime,
                contentDescription = "Wait Time",
                modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE_SMALL),
                tint = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Spacer(modifier = Modifier.width(4.dp))
            Text(
                text = user.waitRange,
                style = MaterialTheme.typography.bodyMedium.copy(
                    fontWeight = FontWeight.SemiBold
                ),
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}
